.rowText {
    display: flex;
    align-items: center;
}
.inlineStylesLevel0 {
    margin: 0px 0.75rem 0px 0px;
}
.inlineStylesLevel1 {
    margin: 0px 0.75rem 0px 25px;
}
.inlineStylesLevel2 {
    margin: 0px 0.75rem 0px 50px;
}
.inlineStylesLevel3 {
    margin: 0px 0.75rem 0px 75px;
}
.inlineStylesLevel4 {
    margin: 0px 0.75rem 0px 100px;
}
.inlineStylesLevel5 {
    margin: 0px 0.75rem 0px 125px;
}
.hrModifier {
    margin: 0px;
    border: 1px solid var(--hps-blue);
    opacity: 0.06;
}